import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
const TeamIntroSection = () => {
  const isMobile = useIsMobile();
  return <div className="mb-16">
      <h2 className="text-2xl md:text-3xl font-serif font-semibold text-patrimoine-dark mb-6 text-center">Notre Équipe d'Experts</h2>
      <div className="w-24 h-1 bg-patrimoine-gold mx-auto mb-8"></div>
      <p className="text-lg text-center text-patrimoine-muted max-w-3xl mx-auto mb-12">
        Notre équipe se compose de professionnels chevronnés dans le domaine de la gestion de patrimoine, offrant un accompagnement personnalisé et des conseils avisés.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="overflow-hidden shadow-xl">
          <img src="/lovable-uploads/265d062b-c016-4755-9d63-25a5c417e7c9.png" alt="Présentation dans nos bureaux" className="w-full h-[300px] object-cover" />
        </div>
        <div className={`flex flex-col justify-center ${isMobile ? "mt-4" : ""}`}>
          <h3 className="text-xl font-serif font-semibold text-patrimoine-dark mb-4">Expertise et Professionnalisme</h3>
          <p className="text-patrimoine-muted">
            Nos conseillers partagent régulièrement leur expertise lors de présentations détaillées sur nos solutions d'investissement, aidant nos clients à prendre des décisions éclairées pour leur avenir financier.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className={`flex flex-col justify-center ${isMobile ? "order-2 mt-4" : "order-1"}`}>
          <h3 className="text-xl font-serif font-semibold text-patrimoine-dark mb-4">Nos Installations</h3>
          <p className="text-patrimoine-muted">
            Nous disposons d'espaces modernes et élégants, dont une salle de conférence dédiée où nous organisons régulièrement des réunions personnalisées et des séminaires pour nos clients. Ces espaces reflètent notre engagement envers l'excellence et le professionnalisme.
          </p>
        </div>
        <div className={`overflow-hidden shadow-xl ${isMobile ? "order-1" : "order-2"}`}>
          <img alt="Salle de conférence de LA PATRIMONIALE" className="w-full h-[300px] object-cover" src="/lovable-uploads/30ebf732-7d91-48c7-94f5-2a7526f06fef.png" />
        </div>
      </div>
    </div>;
};
export default TeamIntroSection;